// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LandingPageCta_wrapper__2rOfZ","ctaButton":"LandingPageCta_ctaButton__VCr3N"};